import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";

export const filterUrgewaldSchema = z.object({
  issuer_id_contains: z
    .preprocess(
      (e: any) => preprocessTextAsyncAutocompleteField(e),
      z.union([
        z.string(),
        z.object({
          id: z.number(),
          name: z.string(),
          text: z.string().nullable().optional(),
        }),
      ]),
    )
    .optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterUrgewaldSchema = z.infer<typeof filterUrgewaldSchema>;

export const fields: Field[] = [
  {
    name: "issuer_id_contains",
    label: "Issuer",
    type: "asyncAutocomplete",
    base_url: "instit-quantilia/issuers",
    column_name: "name",
    id_column: "id",
  },
  {
    name: "created_at_from",
    label: "Created From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created To",
    type: "date",
  },
];

export const client = "qtl - referential";

export function FilterUrgewald() {
  return (
    <FilterTable
      client={client}
      schema={filterUrgewaldSchema}
      tableName="urgewalds"
      customBuildPath={() => `${client}/urgewalds`}
      fields={fields}
    />
  );
}
